import React from "react";
import './vehicles.css'
import VehCard from "./VehCard";

const UserDetails = ({ UserDetails, onSubmit }) => {


    const handleChange = (key, value) => {
        UserDetails = { ...UserDetails, [key]: value };
    }

    const handleSubmit = () => {
        if(UserDetails.pmKeys.length < 7 ){
            alert("PMKEYS must be at least 7 digits");
            return;
        }
        if (UserDetails.pmKeys == null || UserDetails.pmKeys == '') {
            alert("PMKEYS is required");
            return;
        }
        if (UserDetails.firstName == null || UserDetails.firstName == '') {
            alert("First Name is required");
            return;
        }
        if (UserDetails.lastName == null || UserDetails.lastName == '') {
            alert("Last Name is required");
            return;
        }
        if (UserDetails.callsign == null || UserDetails.callsign == '') {
            alert("Callsign is required");
            return;
        }
        onSubmit(UserDetails);
    }

    return (
        <div className="user-form popup">
            <div>
                <h4>User Details</h4>
                <span>PMKEYS:</span>&nbsp;
                <input type="number" value={UserDetails.pmKeys} onChange={(e) => handleChange('pmKeys', e.target.value)} /><br /><br />
                <span>First Name:</span>&nbsp;
                <input type="text" value={UserDetails.firstName} onChange={(e) => handleChange('firstName', e.target.value)} /><br /><br />
                <span>Last Name:</span>&nbsp;
                <input type="text" value={UserDetails.lastName} onChange={(e) => handleChange('lastName', e.target.value)} /><br /><br />
                <span>Callsign:</span>&nbsp;
                <input type="text" value={UserDetails.callsign} onChange={(e) => handleChange('callsign', e.target.value)} />
            </div>
            <div className="save-user-details" onClick={() => handleSubmit()}>Save Details</div>
        </div>
    );
};

export default UserDetails;